<template>
  <a-modal v-model="modal" title="修改" width="80%" :maskClosable="false">
    <ls-api-table
      ref="baseTable"
      :columns="columns"
      :data-source="dataList"
      :table-props="tableProps"
      :scroll="{ y: 300, x: 1600 }"
      bordered
    >
      <!--要求到货数标题-->
      <template #requireDeliveryQuantityTitle>
        <span style="color: red">*</span>
        <span>要求到货数</span>
      </template>
      <!--要求到货数-->
      <template #requireDeliveryQuantity="{ text, record }">
        <a-input-number
          v-model="record.requireDeliveryQuantity"
          :min="0"
          :max="record.factoryUnplanQtyWithWarehouse"
          :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
          :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
          @change="(e) => changeRequireDeliveryQuantity(e, record)"
        />
      </template>
      <!--备注-->
      <template #remark="{ text, record }">
        <a-input
          v-model="record.remark"
          size="small"
          :maxLength="150"
        />
      </template>
      <!--要求到货日期标题-->
      <template #requireDeliveryDayTitle>
        <span style="color: red">*</span>
        <span @click="changeAllDay">要求到货日期</span>
      </template>
      <!--要求到货日期-->
      <template #requireDeliveryDay="{ text, record }">
        <a-date-picker
          v-model="record.requireDeliveryDay"
          @change="changeRequireDeliveryDay($event, record)"
          :disabled-date="disabledStartDate"
        />
      </template>
    </ls-api-table>
    <template slot="footer">
      <a-row>
        <a-space>
          <a-button @click="cancel">取消</a-button>
          <a-button type="primary" @click="submit">确认</a-button>
        </a-space>
      </a-row>
    </template>
  </a-modal>
</template>

<script>
import { YES_OR_NO, BILLTYPE, RECEIPTS_STATUS, INTERNAL_EXCLUSIVE_MAP, COMPLETE_STATUS_MAP } from '@/views/mes/scheduling-plan/receiving-plan/enum'
import common from '../mixins/common'
import {
  apiReceiptPlanUpdateBatch
} from '@/services/module/receiving-plan'

export default {
  name: 'EditModal',
  mixins: [common],
  computed: {
    selectWarehouseList () {
      return this.warehouseList?.()
    }
  },
  data () {
    return {
      YES_OR_NO,
      BILLTYPE,
      RECEIPTS_STATUS,
      modal: false,
      tableProps: {},
      dataList: [],
      columns: [
        {
          dataIndex: 'factoryName',
          title: '供应商',
          width: 230,
          stickyFixed: 'left'
        },
        {
          dataIndex: 'billNo',
          title: '计划单号',
          width: 200
        },
        {
          dataIndex: 'requireDeliveryQuantity',
          // title: "要求到货数",
          scopedSlots: { customRender: 'requireDeliveryQuantity', title: 'requireDeliveryQuantityTitle' },
          width: 150
        },
        {
          dataIndex: 'remark',
          title: '备注',
          width: 150,
          scopedSlots: { customRender: 'remark' }
        },
        {
          dataIndex: 'requireDeliveryDay',
          // title: "要求到货日期",
          scopedSlots: { customRender: 'requireDeliveryDay', title: 'requireDeliveryDayTitle' },
          width: 150
        },
        {
          dataIndex: 'parentBillNo',
          title: '增货计划单',
          width: 150
        },
        {
          dataIndex: 'parentReceiptBillNo',
          title: '增货-送货单',
          width: 150
        },
        {
          dataIndex: 'status',
          title: '单据状态',
          width: 100,
          customRender: (text) => (!this.isNull(text) ? RECEIPTS_STATUS[text] : '')
        },
        {
          dataIndex: 'completeStatus',
          title: '完成状态',
          width: 100,
          customRender: (text) => (!this.isNull(text) ? COMPLETE_STATUS_MAP[text] : '')
        },
        {
          dataIndex: 'dischargeIs',
          title: '是否仓库卸货',
          customRender: (text) => YES_OR_NO[text],
          width: 150
        },
        {
          dataIndex: 'inspectionAtWarehouse',
          title: '是否到仓验货',
          customRender: (text) => YES_OR_NO[text],
          width: 150
        },
        {
          dataIndex: 'newProductIs',
          title: '是否新品',
          customRender: (text) => YES_OR_NO[text],
          width: 150
        },
        {
          dataIndex: 'materialNo',
          title: '物料编码',
          width: 150,
          ellipsis: true
        },
        {
          dataIndex: 'materialName',
          title: '物料名称',
          width: 150,
          ellipsis: true
        },
        {
          dataIndex: 'materialSpec',
          title: '规格描述',
          width: 150,
          ellipsis: true
        },
        {
          dataIndex: 'internalExclusiveIs',
          title: '是否独占(内外部)',
          customRender: (text) => (!this.isNull(text) ? INTERNAL_EXCLUSIVE_MAP[text] : ''),
          width: 150
        },
        {
          dataIndex: 'supplierExclusiveIs',
          title: '是否独占(单工厂)',
          customRender: (text) => YES_OR_NO[text],
          width: 150
        },
        {
          dataIndex: 'supplementQuantity',
          title: '增货数量',
          width: 100
        },
        {
          dataIndex: 'auditQuantity',
          title: '审核数量',
          scopedSlots: { customRender: 'auditQuantity' },
          width: 150
        },
        {
          dataIndex: 'arrangeVolume',
          title: '安排体积',
          width: 100
        },
        {
          dataIndex: 'deliveryVolume',
          title: '送货体积',
          width: 100
        },
        {
          dataIndex: 'cancelQuantity',
          title: '取消数量',
          width: 100
        },
        {
          dataIndex: 'surplusInStockQuantity',
          title: '剩余入库数量',
          width: 150
        },
        {
          dataIndex: 'warehouseName',
          title: '入库仓库',
          width: 150
        },
        {
          dataIndex: 'factoryWarehouseName',
          title: '供应商仓库',
          width: 120
        },
        {
          dataIndex: 'presetLoadVolume',
          title: '预设装载体积',
          width: 150
        },
        {
          dataIndex: 'depositAreaName',
          title: '存放区域',
          width: 120
        },
        {
          dataIndex: 'locationQuantity',
          title: '库位数',
          width: 80
        },
        {
          dataIndex: 'qtyPerLocation',
          title: '标准库位套数',
          width: 150
        },
        {
          dataIndex: 'curOrderSatisfyRate',
          title: '当前订单满足率',
          customRender: (text) => `${text}%`,
          width: 150
        },
        {
          dataIndex: 'sumOrderSatisfyRate',
          title: '累计安排订单满足率',
          customRender: (text) => `${text}%`,
          width: 160
        },
        {
          dataIndex: 'inStockQuantity',
          title: '已入库数量',
          width: 100
        },
        {
          dataIndex: 'arrangeQuantity',
          title: '已安排数量',
          width: 100
        },
        {
          dataIndex: 'unArrangeQuantity',
          title: '未安排数量',
          width: 100
        },
        {
          dataIndex: 'curOverageQuantity',
          title: '本次超出数量',
          width: 120
        },
        {
          dataIndex: 'sumOverageQuantity',
          title: '累计超出数量',
          width: 120
        },
        {
          dataIndex: 'supplierPriorityLevel',
          title: '供应商入库优先级',
          width: 160
        }
      ]
    }
  },
  methods: {
    show (dataList) {
      this.modal = true
      this.dataList = dataList
      this.$nextTick(() => {
        this.$refs.baseTable.getData()
      })
    },
    cancel () {
      this.modal = false
    },
    submit () {
      this.$refs.baseTable.loading = true;
      apiReceiptPlanUpdateBatch(this.dataList).then(() => {
          this.modal = false
          this.$emit('editSuccess')
          this.$message.success('修改成功')
        })
        .finally(() => {
          this.$refs.baseTable.loading = false;
        })
    },
    // 修改要求到货数
    changeRequireDeliveryQuantity (e, record) {
      this.$set(record, 'requireDeliveryQuantity', e)
      this.$set(record, 'totalVolume', this.multiply(record.requireDeliveryQuantity, record.materialVolume))
      this.$set(record, 'locationQuantity', this.divide(record.requireDeliveryQuantity, record.qtyPerLocation))
      this.$set(record, 'sumOrderSatisfyRate', this.divide(this.add(record.inventoryQty, record.requireDeliveryQuantity), record.orderQty))
    },
    // 点击标题批量修改到货日期
    changeAllDay () {
      const items = this.$refs.baseTable.keepSelectList
      if (items.length > 0) {
        items.forEach((item) => {
          this.$set(item, 'requireDeliveryDay', items[0].requireDeliveryDay)
        })
      }
    },
    // 修改要求到货日期
    changeRequireDeliveryDay (e, record) {
      this.$set(record, 'requireDeliveryDay', this.momentFun(e))
    },
    // 要求到货日期
    disabledStartDate (current) {
      // Can not select days before today and today
      return current && current < this.$moment(new Date()).subtract(1, 'days')
    }
  }
}
</script>

<style scoped></style>
